/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesTeam
 */
export interface SalesTeam {
    /**
     * 
     * @type {string}
     * @memberof SalesTeam
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof SalesTeam
     */
    email: string;
}

/**
 * Check if a given object implements the SalesTeam interface.
 */
export function instanceOfSalesTeam(value: object): value is SalesTeam {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function SalesTeamFromJSON(json: any): SalesTeam {
    return SalesTeamFromJSONTyped(json, false);
}

export function SalesTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'email': json['email'],
    };
}

export function SalesTeamToJSON(json: any): SalesTeam {
    return SalesTeamToJSONTyped(json, false);
}

export function SalesTeamToJSONTyped(value?: SalesTeam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
        'email': value['email'],
    };
}

